<template>
  <article v-bind:class="{
    'news-thumbnail': true,
    'full-size': size === 'full',
  }">
    <div class="thumbnail-container">
      <div class="logo-hover">
        <UniHospitalLogoNoText/>
      </div>
      <div :style="`background-image: url(/storage/${imgSrc})`" class="thumbnail-image"></div>

    </div>
    <div class="news-thumbnail-info">
      <h2 class="news-thumbnail-title">{{ title }}</h2>
      <div class="news-thumbnail-date">{{ category }}</div>
    </div>
  </article>
</template>

<script>


import UniHospitalLogoNoText from "@/components/Common/Icons/UniHospitalLogoNoText.vue";

export default {
  name: 'OneSpecialistThumbnail',
  components: {UniHospitalLogoNoText},
  props: {
    imgSrc: {
      type: String,
      required: true
    },
    category: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    size: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.full-size {
  width: 100% !important;

  .thumbnail-container {
    max-width: 100% !important;
    width: 100% !important;
  }
}

.news-thumbnail {
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  font-family: $font-regular;
  color: $color-dark-brown;
  width: 200px;

  .thumbnail-container {
    overflow: hidden;
    background-color: #ddd1cb;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.3s ease-in-out;
    position: relative;
    padding: $spacing-3 $spacing-5 0;
    height: 250px;
    width: 100%;

    .logo-hover {
      display: none;
      position: absolute;
      right: 5%;
      top: 5%;
      animation: rotate 15s linear infinite;
    }

    .thumbnail-image {
      transition: 0.3s ease-in-out;
      background-position: bottom;
      background-size: contain;
      background-repeat: no-repeat;
      height: 100%;
      width: 100%;
    }
  }

  .news-thumbnail-info {
    height: 120px;
    background: $color-grey;
    text-align: left;
    padding: $spacing-3;

    .news-thumbnail-date {
      font-size: 12px;
      margin: $spacing-1 0 0;
    }

    .news-thumbnail-title {
      font-size: 16px;
      font-family: $font-semi-bold;
    }
  }

}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@media screen and (min-width: 768px) {
  .news-thumbnail {
    max-width: 100%;
    width: 100%;

    .thumbnail-container {
      padding: $spacing-3 $spacing-5 0;
      height: 400px;
      width: 100%;
    }


    .news-thumbnail-info {
      height: auto;
    }

    &:hover {
      .thumbnail-container {
        background: $color-blue-accent;
        transition: 0.3s ease-in-out;

        .logo-hover {
          display: block;
        }
      }


    }
  }
}

</style>